import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import refireTrigger from '@/API/Triggers/refireTrigger';

const useRefireTrigger = (onSuccess) => {
    return useMutation({
        mutationFn: async (selectedHistoryId) => {
            try {
                const result = await refireTrigger(selectedHistoryId);

                toast.success('Trigger refired successfully');
                if (onSuccess) {
                    onSuccess();
                }

                return result;
            } catch (error) {
                const errorMessage = `Failed to refire trigger: ${error}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
};

export default useRefireTrigger;
